function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from "prop-types";
import { Widget, WidgetHeader, WidgetTab, WidgetBody, WidgetFooter, WidgetLoading } from "../";
import { getGaDataByMetrics } from "../../resources/functions/";
import { FormatMetric } from "../";
import { Chart } from "../";
import "./AnalyticsReportMetrics.scss";

class AnalyticsReportMetrics extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      tabIndex: 0,
      tabs: undefined,
      loading: true,
      values: {}
    });

    _defineProperty(this, "componentDidUpdate", (prevProps, prevState) => {
      if (prevProps.report !== this.props.report) {
        this.getReport();
      }
    });

    _defineProperty(this, "getCompareHeader", col => {
      const data = col.data;
      const _data$ = data[0],
            metric = _data$.metric,
            xFormat = _data$.xFormat,
            yFormat = _data$.yFormat;
      const s1 = data[0];
      const s2 = data[1];
      let value = React.createElement(FormatMetric, {
        type: "INTEGER",
        value: s1.total
      }); // formatNumber(s1.total);

      let change, trending;

      if (s1.total > s2.total) {
        change = (s1.total - s2.total) / s1.total * 100;
        trending = "up";
      } else if (s2.total > s1.total) {
        change = (s2.total - s1.total) / s2.total * 100;
        trending = "down";
      } else {
        change = 0;
        trending = "flat";
      }

      change = React.createElement(FormatMetric, {
        type: "PERCENT",
        value: change
      }); // formatPercent(change)

      if (yFormat === "PERCENT") {
        value = React.createElement(FormatMetric, {
          type: "PERCENT",
          value: s1.average
        }); // formatPercent(s1.average)
      }

      if (yFormat === "TIME") {
        value = React.createElement(FormatMetric, {
          type: "DURATION",
          value: s1.average
        }); // formatDuration(s1.average)
      }

      return {
        id: metric,
        label: metric,
        value: value,
        change: change,
        trending: trending
      };
    });

    _defineProperty(this, "getHeader", col => {
      const metric = col.metric,
            xFormat = col.xFormat,
            yFormat = col.yFormat,
            data = col.data,
            total = col.total,
            average = col.average;

      if (!data.length) {
        return false;
      }

      const compare = this.props.compare;

      if (compare && data[0] && data[1]) {
        return this.getCompareHeader(col);
      }

      let value = React.createElement(FormatMetric, {
        type: "INTEGER",
        value: total
      }); // formatNumber(total);

      if (yFormat === "PERCENT") {
        value = React.createElement(FormatMetric, {
          type: "PERCENT",
          value: average
        }); // formatPercent(average)
      }

      if (yFormat === "TIME") {
        value = React.createElement(FormatMetric, {
          type: "DURATION",
          value: average
        }); // formatDuration(average)
      }

      return {
        id: metric,
        label: metric,
        value: value
      };
    });

    _defineProperty(this, "onSelectTab", index => {
      this.setState({
        tabIndex: index
      });
    });

    _defineProperty(this, "renderChart", (metric, index) => {
      let _this$props = this.props,
          theme = _this$props.theme,
          colors = _this$props.colors,
          type = _this$props.type,
          compare = _this$props.compare,
          stacked = _this$props.stacked;
      let yScaleMax = "auto";
      const maximum = metric.maximum,
            minimum = metric.minimum,
            yFormat = metric.yFormat,
            data = metric.data,
            startDate = metric.startDate,
            endDate = metric.endDate,
            days = metric.days;

      if (yFormat === "PERCENT") {
        yScaleMax = Math.ceil((maximum + 1) / 10) * 10;
        console.log("MAX", yScaleMax);
      }

      if (index === this.state.tabIndex) {
        return React.createElement(Chart, _extends({}, metric, {
          type: type,
          compare: compare,
          stacked: stacked,
          yScaleMax: yScaleMax,
          outerMargin: {
            top: 20,
            right: 20,
            bottom: 20,
            left: 20
          },
          theme: theme,
          colors: colors,
          key: index
        }));
      }

      return false;
    });

    _defineProperty(this, "renderTab", (tab, index) => {
      const theme = this.props.theme;

      const _this$getHeader = this.getHeader(tab),
            id = _this$getHeader.id,
            label = _this$getHeader.label,
            value = _this$getHeader.value,
            change = _this$getHeader.change,
            trending = _this$getHeader.trending;

      const selected = this.state.tabIndex === index;

      if (change && trending) {
        return React.createElement(WidgetTab, {
          theme: theme,
          selected: selected,
          onClick: () => this.onSelectTab(index),
          key: index
        }, React.createElement("h2", {
          className: "admin-metric__label"
        }, React.createElement(FormatMetric, {
          name: id
        })), React.createElement("h3", {
          className: "admin-metric__value"
        }, value), React.createElement("p", {
          className: "admin-metric__change",
          "data-trending": trending
        }, change));
      }

      return React.createElement(WidgetTab, {
        theme: theme,
        selected: selected,
        onClick: () => this.onSelectTab(index),
        key: index
      }, React.createElement("h2", {
        className: "admin-metric__label"
      }, label), React.createElement("h3", {
        className: "admin-metric__value"
      }, value));
    });

    _defineProperty(this, "getReport", () => {
      const _this$props2 = this.props,
            report = _this$props2.report,
            metrics = _this$props2.metrics,
            dimension = _this$props2.dimension;
      this.setState({
        tabs: undefined,
        loading: true
      });

      if (!report) {
        return false;
      }

      const data = getGaDataByMetrics(report, metrics, dimension);
      const tabs = Object.values(data);
      this.setState({
        tabs: tabs,
        loading: false
      });
    });
  }

  componentDidMount() {
    this.getReport();
  }

  render() {
    const _this$props3 = this.props,
          theme = _this$props3.theme,
          widgetType = _this$props3.widgetType,
          widgetSize = _this$props3.widgetSize,
          debug = _this$props3.debug,
          reportType = _this$props3.reportType,
          scope = _this$props3.scope,
          loadingTitle = _this$props3.loadingTitle,
          loadingDescription = _this$props3.loadingDescription;
    const _this$state = this.state,
          tabs = _this$state.tabs,
          values = _this$state.values;
    const loading = this.state.loading || this.props.loading;

    if (loading) {
      return React.createElement(Widget, this.props, React.createElement(WidgetLoading, {
        theme: theme,
        title: loadingTitle,
        description: loadingDescription
      }));
    }

    return React.createElement(Widget, this.props, React.createElement(WidgetHeader, null, tabs.map(this.renderTab)), React.createElement(WidgetBody, null, tabs.map(this.renderChart)));
  }

}

_defineProperty(AnalyticsReportMetrics, "defaultProps", {
  loadingTitle: "Loading metrics report",
  reportType: "metrics",
  scope: undefined,
  widgetType: "analytics-report-metrics",
  widgetSize: "2:6",
  theme: {},
  report: undefined,
  metrics: [],
  dimension: undefined,
  type: "line",
  compare: true,
  stacked: false,
  debug: false
});

AnalyticsReportMetrics.propTypes = process.env.NODE_ENV !== "production" ? {
  loadingTitle: PropTypes.string,
  loadingDescription: PropTypes.string,
  scope: PropTypes.string
} : {};
export default AnalyticsReportMetrics;